import { render } from "./ProfitLossLotto.vue?vue&type=template&id=0732e0c8"
import script from "./ProfitLossLotto.vue?vue&type=script&lang=js"
export * from "./ProfitLossLotto.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__